module.exports = __webpack_public_path__ + "static/graph-bottom-47913ab29fe9204453ac5f0fc5c7dc73.png";